import { Activity } from './Activity';

const createdAtList = [
  '2021-04-30T03:04:32+09:00',
  '2021-02-28T00:43:54+09:00',
  '2021-05-16T07:17:17+09:00',
  '2021-04-12T16:08:04+09:00',
  '2021-05-27T17:02:58+09:00',
  '2021-05-02T02:29:52+09:00',
  '2021-03-07T19:21:21+09:00',
  '2021-03-10T08:28:14+09:00',
  '2021-03-09T17:14:04+09:00',
  '2021-03-19T03:29:23+09:00',
  '2021-04-16T10:48:50+09:00',
  '2021-04-22T19:19:21+09:00',
  '2021-03-12T04:55:41+09:00',
  '2021-05-04T20:31:59+09:00',
  '2021-04-01T19:36:00+09:00',
  '2021-05-24T09:25:14+09:00',
  '2021-04-07T01:30:44+09:00',
  '2021-04-29T23:29:22+09:00',
  '2021-02-22T06:03:53+09:00',
  '2021-02-14T14:04:33+09:00',
];

export const activityListExample = Activity.array()
  .parse([
    //各タイプのアクティビティを5個ずつ作る
    ...Array.from({ length: 5 }, (_, i) => ({
      id: `post-${i}`,
      createdAt: createdAtList[i],
      userId: 'user-0',
      userName: 'ユーザー 0',
      userAvatarURL: 'https://picsum.photos/id/64/200/200',
      type: 'post',
      payload: {
        type: 'post',
        id: `post-${i}`,
        title: `投稿 ${i}`,
      },
    })),
    ...Array.from({ length: 5 }, (_, i) => ({
      id: `event-${i}`,
      createdAt: createdAtList[i + 5],
      userId: 'user-0',
      userName: 'ユーザー 0',
      userAvatarURL: 'https://picsum.photos/id/64/200/200',
      type: 'event',
      payload: {
        type: 'event',
        id: `event-${i}`,
        title: `イベント ${i}`,
      },
    })),
    ...Array.from({ length: 5 }, (_, i) => ({
      id: `campaign-${i}`,
      createdAt: createdAtList[i + 10],
      userId: 'user-0',
      userName: 'ユーザー 0',
      userAvatarURL: 'https://picsum.photos/id/64/200/200',
      type: 'campaign',
      payload: {
        type: 'campaign',
        id: `campaign-${i}`,
        title: `キャンペーン ${i}`,
      },
    })),
    ...Array.from({ length: 5 }, (_, i) => ({
      id: `topic-${i}`,
      createdAt: createdAtList[i + 15],
      userId: 'user-0',
      userName: 'ユーザー 0',
      userAvatarURL: 'https://picsum.photos/id/64/200/200',
      type: 'topic',
      payload: {
        type: 'topic',
        id: `topic-${i}`,
        title: `トピック ${i}`,
      },
    })),
  ])
  .sort((a, b) => b.createdAt.localeCompare(a.createdAt));
